import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        if (!cancelled) setUser(data);
      } catch (e) {
        if (!cancelled) setUser(false);
      } finally {
        if (!cancelled) setReady(true);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const value = useMemo(() => ({
    user,
    ready,
    isAdmin: user && user.role === "admin",
    async login(email, password) {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return data;
    },
    async register(payload) {
      const { data } = await api.post("/auth/register", payload);
      setUser(data);
      return data;
    },
    async logout() {
      try { await api.post("/auth/logout"); } catch (_) {}
      setUser(false);
    },
  }), [user, ready]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
